module.exports = __webpack_public_path__ + "img/button.1b396621.png";